

export class PostSyncAction {

    clazz = ''; // picture_transformation.PictureTransformationProcessor
    config = ''; // transform.xml

    constructor() {

    }

}
